<template>
  <div id="achievement">
      <div class="page-header header-filter" data-parallax="true" style="background-image: url('static/img/achievement.jpg'); height:50vh">
            <div class="container">
                <div class="row">
                <div class="col-md-8 ml-auto mr-auto">
                    <div class="brand text-center">
                    <h1 class="title" id="hide_edit" @click="edit_major_projects">主要研究計畫</h1>
                    <h3 class="title description">Major Projects</h3>
                    </div>
                </div>
                </div>
            </div>
        </div>
        <div class="main main-raised">
            <div class="container">
              <div class="section text-center">
                <!--nav pills -->
                <div id="navigation-pills">
                  <div class="row">
                    <div class="col-md- ml-auto mr-auto">
                      <ul class="nav nav-pills nav-pills-rose">
                          <template v-for="(item, index) in tab_list">
                                <li v-if="index == 0" class="nav-item" :key="item.title_cht + index">
                                    <a class="nav-link active" :href="'#' + item.title_cht" data-toggle="tab">{{ item.title_cht }}</a>
                                </li>
                                <li v-else class="nav-item" :key="item.title_cht">
                                    <a class="nav-link" :href="'#' + item.title_cht" data-toggle="tab">{{ item.title_cht }}</a>
                                </li>
                          </template>
                        <!-- <li class="nav-item">
                          <a class="nav-link active" href="#pill1" data-toggle="tab">產學合作計畫 / 金額</a>
                        </li>
                        <li class="nav-item">
                          <a class="nav-link" href="#pill2" data-toggle="tab">專利 / 技轉</a>
                        </li> -->
                      </ul>
                    </div>
                  </div>
                  </div>
                  <!--end nav pills -->
                </div>
                <div class="tab-content tab-space">
                    <template v-for="(item, index) in data">
                        <div v-if="index == 0" class="tab-pane active" :id="item.title_cht" :key="index">
                            <table class="table">
                                <tbody>
                                    <template v-for="(sub_item, sub_index) in item.sub_list">
                                        <tr :key="sub_index">
                                            <td>
                                                <strong>{{ sub_item.projects_cht }}</strong>
                                                <br>
                                                {{ sub_item.projects_eng }}
                                            </td>
                                            <td>
                                                <strong>{{ sub_item.co_worker_cht }}</strong>
                                                <br>
                                                {{ sub_item.co_worker_eng }}
                                            </td>                                
                                        </tr>
                                    </template>
                                </tbody>
                            </table>
                        </div>
                        <div v-else class="tab-pane" :id="item.title_cht" :key="index">
                            <table class="table">
                                <tbody>
                                    <template v-for="(sub_item, sub_index) in item.sub_list">
                                        <tr :key="sub_index">
                                            <td>
                                                <strong>{{ sub_item.projects_cht }}</strong>
                                                <br>
                                                {{ sub_item.projects_eng }}
                                            </td>
                                            <td>
                                                <strong>{{ sub_item.co_worker_cht }}</strong>
                                                <br>
                                                {{ sub_item.co_worker_eng }}
                                            </td>                                
                                        </tr>
                                    </template>
                                </tbody>
                            </table>
                        </div>
                    </template>
                </div>
            </div>
        </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "achievement",
  props: [],
  data() {
    return {
      tab_list:[],
      data:[]
    };
  },
  methods: {
    getmajor_projects: function(){
      var vm = this;
    //   console.log('get_major_projects')
       axios
          .get(`/api/getmajorProjects`)
          .then(res => {
            // console.log(res.data);
            var data = res.data.data;
            for(var i = 0; i < data.length; i++){
                var title_cht = data[i].title_cht;

                if(i == 0){
                    vm.tab_list.push({
                        title_cht: data[i].title_cht,
                        title_eng: data[i].title_eng
                    });
                    vm.data.push({
                        title_cht: data[i].title_cht,
                        title_eng: data[i].title_eng,
                        sub_list:[
                            {
                                projects_cht: data[i].projects_cht,
                                projects_eng: data[i].projects_eng,
                                co_worker_cht: data[i].co_worker_cht,
                                co_worker_eng: data[i].co_worker_eng
                            }
                        ]
                    });
                }
                else{
                    var data_len = vm.data.length;
                    if(title_cht == data[i-1].title_cht){
                        vm.data[data_len - 1].sub_list.push({
                            projects_cht: data[i].projects_cht,
                            projects_eng: data[i].projects_eng,
                            co_worker_cht: data[i].co_worker_cht,
                            co_worker_eng: data[i].co_worker_eng
                        });
                    }
                    else{
                        vm.tab_list.push({
                            title_cht: data[i].title_cht,
                            title_eng: data[i].title_eng
                        });
                        vm.data.push({
                            title_cht: data[i].title_cht,
                            title_eng: data[i].title_eng,
                            sub_list:[
                                {
                                    projects_cht: data[i].projects_cht,
                                    projects_eng: data[i].projects_eng,
                                    co_worker_cht: data[i].co_worker_cht,
                                    co_worker_eng: data[i].co_worker_eng
                                }
                            ]
                        });
                    }
                }
            }

          })
          .catch(err => {
            console.log(err);
          });
    },
    edit_major_projects: function(){
        var vm = this;
        document.querySelector('#hide_edit').addEventListener('click', function (evt) {
            // console.log(evt.detail)

            if(evt.detail === 3){
                vm.$router.push("/about/edit_achievement").catch(error => {
                    if (error.name != "NavigationDuplicated") {
                        throw error;
                    }
                });
            }
        });
    }
  },
  filters: {},
  computed: {},
  created() {
      this.getmajor_projects();
  },
  mounted() {
  },
  components: {},
  watch: {}
};
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/pages/about/achievement.vue